import { DocumentRevisionStatus } from '../../types/document-revision-status.types';

export const COMPLETED_HOMOLOGATION_STATUSES: DocumentRevisionStatus[] = [
  DocumentRevisionStatus.APPROVED,
  DocumentRevisionStatus.VERIFIED,
  DocumentRevisionStatus.CURRENT,
  DocumentRevisionStatus.INACTIVE,
  DocumentRevisionStatus.OBSOLETE,
];

export function hasCompletedHomologation(
  status: DocumentRevisionStatus | null | undefined
): boolean {
  if (!status) return false;
  return COMPLETED_HOMOLOGATION_STATUSES.includes(status);
}

